<template>
  <div class="zg-steps">
    <div
      v-for="(step, index) in steps"
      :key="index"
      class="step"
      :class="{ active: index <= active - 1 }"
    >
      <div class="step-prefix"></div>
      <div class="text-container">
        <div class="step-name m-b15">{{ step.title }}</div>
        <slot name="desc" :step="step"
          ><div class="step-time">{{ step.time | dataFormat(timeFormat) }}</div></slot
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'zg-step',
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    active: {
      type: Number,
      default: 0
    },
    timeFormat: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="stylus" scoped>
.zg-steps
    display flex
  .step
    display flex
    align-items baseline
    min-width 140px
    height 60px
    &-name
      font-size 16px
      color #CCCCCC
      font-weight bold
      line-height @font-size
    &-time
      font-size 12px
      color #999999
  .step-prefix
    background #F0F0F0
    width 6px
    height @width
    margin 5px 10px
    align-self flex-start
  .active
    color #333333
    .step-prefix
      background #92CF54
    .step-name
      color #333333
</style>
